@if (!isFormBuilderRoute() && hasHeader) {
  <app-top-menu-dashboard></app-top-menu-dashboard>
}
@if (isContributionsDashboardRoute()) {
  <app-contributions-dashboard></app-contributions-dashboard>
} @else {
  <router-outlet></router-outlet>
  @if (showFooter) {
    @if (smallScreen || !isEOSCReadinessDashboardRoute()) {
      <app-full-footer></app-full-footer>
    } @else {
      <div [ngStyle]="{'margin-left': isOpen ? '280px' : '100px'}">
        <app-full-footer></app-full-footer>
      </div>
    }
  }
}

<div class="feedback-button-wrapper">
  <a href="https://forms.office.com/Pages/DesignPageV2.aspx?subpage=design&FormId=9mC7bDIJYEq9kZao08KKk0aiYWITFuJPhS11m
           Nf23HBURUVBUUdZM0JJTkZKNDNTNTg4TDBYQVRNNyQlQCN0PWcu&Token=fa6bea577f504175b43a56a6acee90fc"
           class="uk-flex uk-flex-middle uk-button-primary feedback-button"
           target="_blank"
           uk-tooltip="Give us feedback" aria-label="Give us feedback">
    <span class="material-symbols-outlined">feedback</span>
  </a>
</div>

<app-cookie-consent></app-cookie-consent>
